module.exports = __webpack_public_path__ + "static/media/features_bg_sp.abd192a3.jpg";